import { FunctionComponent } from "react";
import { spriteData } from "../../dist/svg-sprite/separator-icons-data.js";
import { SeparatorIconName } from "../types/index.js";
import SvgUseIcon from "./SvgUseIcon.js";

const { spriteFileName, viewBoxes, symbolIdPrefix } = spriteData;

interface Props {
  className?: string;
  glyph: SeparatorIconName;
}

const SeparatorIcon: FunctionComponent<Props> = ({ glyph, className }) => (
  <SvgUseIcon
    className={className}
    viewBox={viewBoxes[glyph]}
    glyph={glyph}
    symbolIdPrefix={symbolIdPrefix}
    spriteFileName={spriteFileName}
  />
);

export default SeparatorIcon;
